/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".timeFormControl[_ngcontent-%COMP%]{width:70px;display:inline}\n/*# sourceMappingURL=time-picker.component.css.map*/"];
export { styles as styles };
